import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-louisiana-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./louisiana-state-form.component.html",
  styleUrl: "./louisiana-state-form.component.scss",
})
export class LouisianaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
